import type { TourSection } from './types';

export const productsNewSections: TourSection[] = [
  {
    id: 'form',
    label: 'Datos básicos',
    steps: [
      {
        target: '[data-tour="product-form-sku"]',
        title: 'SKU (código del producto)',
        content:
          'Identificador único del producto. NO se puede cambiar después de crear. Suele ser un código alfanumérico — el mismo que usa el sistema interno de la empresa.',
      },
      {
        target: '[data-tour="product-form-name"]',
        title: 'Nombre',
        content:
          'A medida que escribes el nombre, el slug se arma solo (versión simplificada del nombre para usar en URLs). Si editas el slug a mano después, queda como lo dejes.',
      },
    ],
  },
  {
    id: 'category-brand',
    label: 'Marca y categoría',
    steps: [
      {
        target: '[data-tour="product-form-brand"]',
        title: 'Marca y categoría',
        content:
          'Buscadores con sugerencias. Si la marca o categoría que necesitas no aparece, primero créala desde la sección de Marcas o Categorías (en el menú lateral).',
      },
    ],
  },
];
